import React from 'react';
import PropTypes from 'prop-types';

import PayUIcons from 'deltoid/core/PayUIcons';

const List = ({
  data,
}) => {
  return (
    <ul className='co-validation-list'>
      {data.map((v, index) => (
        <li className='d-flex flex-row align-items-baseline valid' key={`point-${index}`}>
          <PayUIcons
            type={v.type==='valid' ? 'checklist' : 'exclm'}
            size='16px'
            color={v.type==='valid' ? 'primary' : 'danger'}/>
          <p className='align-self-center'>{v.content}</p>
        </li>
      ))}
    </ul>
  );
};

export default List;
